<template>
  <div class="honour">
    <!-- <div class="text">
        <div class="title">荣誉奖项</div>
        <div class="eng">Honorany award</div>
        <div class="des">
            公公公司誉绍荣介公荣介司誉绍公荣介司誉绍司誉绍荣绍公司誉公司荣誉介绍司荣誉介绍公公司荣誉介绍司荣誉介绍公司荣誉介绍司荣誉介绍公公公公司荣誉介绍司荣誉介绍公司荣誉介绍司荣誉介绍公公司荣誉介绍司荣誉介绍公司荣誉介绍司荣誉介绍公公公司荣誉介绍司荣誉介绍公司荣誉介绍司荣誉介绍公公司荣誉介绍司荣誉介绍公司荣誉介绍司荣誉介绍
        </div>
    </div>
    <div class="cont">
        <div class="item" v-for='(i,k) in data' :key='k'>
            <div class="box">
                <img :src="i.url" alt="">
                <div class="award">{{i.name}}</div>
                <div class="date">{{i.content}}</div>
            </div>
        </div>
    </div> -->
    <!-- <page :size='5' :total='21' /> -->
    <ul>
      <li v-for='(i,k) in showData' :key='k' @click="goDetail(i)">{{i.name}}</li>
    </ul>
    <div class="page">
      <i class="left iconfont icon-youjiantou" @click="prePage()"></i>
      <div class="item" :class="{active: current===k}" v-for='(i,k) in new Array(Math.ceil(total / size))' :key='k'>
        <div @click="currentPage(k)">{{k+1}}</div>
      </div>
      <i class="right iconfont icon-youjiantou" @click="nextPage()"></i>
    </div>
  </div>
</template>

<script>
  import common from '../common'

  export default {
    mixins: [common],
    components: {},
    props: {
      data: Array
    },
    data() {
      return {
        showData: [],
        total: this.data.length,
        size: 10,
        current: 0,
        langType: ""
      }
    },
    methods: {
      goDetail(i) {
        this.$emit('detail', i)
      },
      created() {
      },
      nextPage() {
        if (this.current + 1 == Math.ceil(this.total / this.size)) {
        } else {
          this.current = this.current + 1;
        }
      },
      // 上一页
      prePage() {
        if (this.current == 0) {
        } else {
          this.current = this.current - 1;
        }
      },
      // 点击页码
      currentPage(i) {
        this.current = i;
        this.watch
      }
    },
    watch: {
      data: function (newData, oldData) {
        console.log("order", newData)  //newData就是orderData
        this.total = newData.length;
        this.showData = newData.slice(this.current * this.size, (this.current + 1) * this.size);
        //	methods的函数在这里调用可以获取到newOrderData的值
      },
      current: function (newData, oldData) {
        console.log("current", newData)  //newData就是orderData
        this.showData = this.data.slice(newData * this.size, (newData + 1) * this.size);
        //	methods的函数在这里调用可以获取到newOrderData的值
      }
    }

  }
</script>

<style lang="stylus" scoped>
  @import "~styl/mixin.styl"
  .honour
    min-height 350px
    mt(20)
    fs(0)

    ul
      pl(30)

      li
        fs(17)
        c(gray)
        lh(37)
        _hover()

    .text
      ta(center)

      .title
        fs(19)

      .eng
        pt(5)
        fs(16)
        c(gray)

      .des
        mt(20)
        fs(14)
        lh(30)

    .cont
      mt(65)
      _flex()
      flex-wrap wrap

      .item
        h(420)
        lh(420)
        width 30%
        mb(30)
        border 1px solid gray
        ta(center)

        .box
          ib()
          ln()
          va(middle)

          img
            h(250)
            w(280)

          .award
            fs(15)
            pb(20)

          .date
            w(350)
            fs(15)
            textover()

  theme = #f7aa05

  .page
    ta(center)
    fs(0)

    .item
      ib()
      w(40)
      h(30)
      ml(10)
      mr(10)
      va(middle)
      fs(17)
      lh(30)
      c(gray)
      _hover()

      &.active
        bg(theme)
        c(#fff)

    .left
      fs(15)
      c(gray)
      ib()
      transform rotate(180deg)
      vertical-align -4px
      mr(10)

      &:hover
        cursor pointer

    .right
      &:hover
        cursor pointer
      ml(10)
      va(middle)
      c(gray)
      fs(15)
</style>



// WEBPACK FOOTER //
// src/components/msg/honour.vue